// extracted by mini-css-extract-plugin
export default {"keyValue":"KeyValue_keyValue__fiYP6","title":"KeyValue_title__Oi5YT","value":"KeyValue_value__STpmv"};